import type { Reply } from 'models';
import { useCallback } from 'react';

type P = {
  eventId: string;
};

/**
 * Normalizes social event comments for the generic Comments component.
 *
 * Social events are handled by Node, but comment properties
 * top_parent_id and top_parent_shareable_id contain Rails IDs.
 * Since comments are generic and shared hooks such as useGetCommentParentId
 * rely on these values to resolve the parent entity, we replace them with the Node event ID.
 */
export const useGetSocialEventComments = ({ eventId }: P) =>
  useCallback(
    ({ comments }: { comments: Reply[] }) => {
      const getSocialEventComments = (replies: Reply[], parentId: string): Reply[] =>
        replies.map((reply) => ({
          ...reply,
          parentId,
          replies: reply.replies ? getSocialEventComments(reply.replies, reply.id) : undefined,
          topParentId: eventId,
          topParentShareableId: eventId,
        }));

      return getSocialEventComments(comments, eventId);
    },
    [eventId],
  );
